import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormTinsionResult } from './FormTinsionResult';
import { DeleteTinsionResult } from './DeleteTinsionResult';
import { Dialog } from 'primereact/dialog';

export const ModalTinsionResult = (props) => {

    const {
        modal, tittle, closeDialog, method,
        name,
        handleInputChange, loading,titleDelete,
        saveCreate,saveUpdateBacterium,saveDeleteBacterium
    } = props;

    return (
        <Dialog 
            header={tittle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
            {
                method === "create"
                    ? <FormTinsionResult
                        button={"Crear"}
                        {...{ closeDialog, loading,name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormTinsionResult
                            button={"Actualizar"}
                            {...{ closeDialog, loading,name, handleInputChange,methodAction: saveUpdateBacterium }} />
                        :
                        // <DeleteTinsionResult {...{ toggle, loading, saveDeleteBacterium,titleDelete }} />
                        null
            }
        </Dialog>
    )
}
